import { fork, all } from 'redux-saga/effects';
import couponExchangeSaga from './couponExchange';
import sslSaga from './ssl';
import newFeedbackSaga from './newFeedback';
import newUserSaga from './newUser';
import letterSaga from './letter';
import turntableSaga from './turntable';

export default function* activitySaga() {
  yield all([
    fork(couponExchangeSaga),
    fork(sslSaga),
    fork(newFeedbackSaga),
    fork(newUserSaga),
    fork(letterSaga),
    fork(turntableSaga),
  ]);
}
